<aca-alert-message #alertComponent></aca-alert-message>

<div class="loginBackground">
  <p-card *ngIf="loadLoginControls" class="loginPanel p-grid" styleClass="app-frame accela-theme">
    <div *ngIf="ssoLoginEnabled;then ssoLoginpanel else loginpanel"></div>
    <ng-template #loginpanel>
      <aca-login-panel (message)="this.showError($event)"></aca-login-panel>
    </ng-template>
    <ng-template #ssoLoginpanel>
      <aca-sso-login-panel (message)="this.showError($event)"></aca-sso-login-panel>
    </ng-template>
  </p-card>
</div>
